<template>
  <EditorPanel :loading-save="loadingSave">
    <EditorSectionLabel v-if="typeof siteSetting.style_socials != 'object'">
      {{ $t("harmony.choose-style") }}<span style="color: #8e84c0">{{ getSocialStyle(siteSetting.style_socials) }}</span>
    </EditorSectionLabel>
    <EditorSectionLabel v-else>
      {{ $t("harmony.choose-style") }}<span style="color: #8e84c0">{{ $t('harmony.customized') }}</span>
    </EditorSectionLabel>
    <div class="socials-div frame-div rounded-xl px-2 d-flex items-center justify-center">
      <div class="d-flex justify-center align-center" @click="setSocialStyle('default')"
        :aria-label="$t('harmony.style-default')" :aria-pressed="selectedSocial === 'default'" tabindex="0"
        @keyup.enter="setSocialStyle('default')" @keyup.space.prevent="setSocialStyle('default')">
        <div class="px-2">
          <img :src="require('@/assets/socials/default/facebook.svg')" class="socials-icon" alt="" aria-hidden="true">
          <div v-if="selectedSocial === 'default'" class="d-flex justify-center align-items-center mt-1">
            <v-progress-circular v-if="loadingSave" indeterminate :size="10" :width="2"
              color="#8e84c0"></v-progress-circular>
            <v-icon v-else class="selected-icon" size="small" aria-hidden="true">mdi-check-circle</v-icon>
          </div>
        </div>
      </div>

      <div class="d-flex justify-center align-center" v-for="(social, index) in socialsBar" :key="index"
        @click="setSocialStyle(index + 1)"
        :aria-label="$t('harmony.style-n', { n: index + 1 })" :aria-pressed="selectedSocial === index + 1" tabindex="0"
        @keyup.enter="setSocialStyle(index + 1)" @keyup.space.prevent="setSocialStyle(index + 1)">
        <div v-if="index !== 1" class="px-2">
          <img :src="socialStyleIcon(index + 1, social)" class="socials-icon" alt="" aria-hidden="true">
          <div v-if="selectedSocial === index + 1" class="d-flex justify-center align-items-center mt-1">
            <v-progress-circular v-if="loadingSave" indeterminate :size="10" :width="2"
              color="#8e84c0"></v-progress-circular>
            <v-icon v-else class="selected-icon" size="small" aria-hidden="true">mdi-check-circle</v-icon>
          </div>
        </div>
      </div>
      <v-tooltip bottom color="#8e84c0">
        <template v-slot:activator="{ on, attrs }">
          <div class="d-flex justify-center align-items-center flex-column px-1" @click="addStyleColor" v-bind="attrs"
            v-on="on" :aria-label="$t('harmony.customize-icon')" tabindex="0" role="button"
            @keyup.enter="addStyleColor" @keyup.space.prevent="addStyleColor">
            <v-icon class="plus-social-style rounded-xl" color="#8e84c0" aria-hidden="true">
              mdi-plus
            </v-icon>
            <div class="d-flex justify-center align-items-center mt-2">
              <v-progress-circular v-if="loadingSave && typeof siteSetting.style_socials == 'object'" indeterminate
                :size="10" :width="2" color="#8e84c0"></v-progress-circular>
              <v-icon v-if="!loadingSave && typeof siteSetting.style_socials == 'object'" class="selected-icon"
                size="small" aria-hidden="true">mdi-check-circle</v-icon>
            </div>
          </div>
        </template>
        <span v-html="$t('harmony.customize-icon')"></span>
      </v-tooltip>

      <v-dialog v-model="modalAddStyleColor">
        <v-card class="rounded-xl pa-6 modal-social-color">
          <div class="d-flex flex-column">
            <div class="d-flex justify-center align-center">
              <div class="setSocialsStyle mb-6 mx-auto"
                :style="{ background: ('#' + styleSocial.color), borderRadius: styleSocial.border + 'px' }">
                <img :src="currentImage" class="ma-auto" alt="" aria-hidden="true">
              </div>
            </div>

            <v-text-field type="number" :label="$t('harmony.border-radius')" persistent-hint v-model="styleSocial.border"
              outlined dense min="0" max="50" prepend-outer-icon="mdi-border-radius"></v-text-field>

            <v-color-picker v-model="colorPersonalized" dot-size="25" hide-inputs hide-mode-switch
              swatches-max-height="200" canvas-height="100" class="remove-preview">
            </v-color-picker>
            <v-btn :disabled="loadingSave" :loading="loadingSave" outlined color="#8e84c0"
              class="text-black mt-6 rounded-md mx-auto py-4 px-10 v-btn v-btn--outlined theme--light v-size--small" small
              @click="saveStyleColor" max-width="100px" :aria-label="$t('harmony.save-style-color')">
              <v-icon center aria-hidden="true">
                mdi-plus
              </v-icon>
            </v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>

    <EditorSectionLabel :text="$t('harmony.add-socialNetworks')" />
    <v-text-field v-for="(item, key) in socialItems" :key="countSocials > 0 ? item.id : key" v-model="item.nick"
      @input="handleInput(countSocials > 0 ? item.id : key)"
      :append-outer-icon="changes[countSocials > 0 ? item.id : key] ? 'mdi-send-check-outline' : 'mdi-trash-can-outline'"
      @click:append-outer="changes[countSocials > 0 ? item.id : key] ? saveSocial(item) : deleteSocial(item)"
      color="#9BA9BD" :placeholder="$t('harmony.user-nick')" outlined dense class="mb-2"
      :aria-label="$t('harmony.social-nick-label', { name: item.name })">
      <template v-slot:prepend>
        <div v-if="typeof siteSetting.style_socials === 'object'"
          class="style-socials d-flex justify-center align-center"
          :style="{ background: ('#' + styleSocial.color), borderRadius: (styleSocial.border / 3) + 'px' }">
          <img :src="require(`@/assets/socials/no-styles/${item.name}.png`)" alt="" aria-hidden="true" />
        </div>
        <v-img v-else class="icon-redes contain"
          :class="siteSetting.style_socials === 'default' ? 'style-socials d-flex justify-center align-center' : ''"
          :src="require(`@/assets/socials/${siteSetting.style_socials}/${item.name}.svg`)" alt="" aria-hidden="true"></v-img>
      </template>
    </v-text-field>

    <v-dialog v-model="dialog" max-width="300px">
      <v-card>
        <v-card-title class="text-h6 menu-text px-4">{{ $t("harmony.add-new-socialNetwork") }}</v-card-title>
        <v-card-text class="pb-0 px-4">
          <v-autocomplete :items="listSocials" v-model="newSocial.name" :label="$t('harmony.select-socialNetwork')"
            color="#9BA9BD" class="mt-2" outlined dense item-value="value" item-text="name" auto-select-first
            :rules="[rules.required]" />
          <v-text-field color="#9BA9BD" :placeholder="getSocialPlaceholder(newSocial.name)" outlined dense
            v-model="newSocial.nick" :rules="[rules.required]"></v-text-field>
        </v-card-text>
        <v-card-actions class="justify-center pb-4">
          <v-btn outlined color="#8e84c0" class="text-black mt-0 rounded-md py-4 px-6" small :loading="loadingSave"
            :disabled="loadingSave || !validNick" @click="saveNewSocial">
            <v-icon center>
              mdi-check-bold
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <template #actions>
      <v-btn :disabled="countSocials >= 10 || loadingSave" :loading="loadingSave" outlined
        class="text-black rounded-md py-4 px-10 editor-panel__confirm-btn" small @click="showAddDialog"
        :aria-label="$t('harmony.add-new-socialNetwork')">
        <v-icon center aria-hidden="true">mdi-plus</v-icon>
      </v-btn>
    </template>
  </EditorPanel>
</template>

<script>
import EditorPanel from './EditorPanel.vue'
import EditorSectionLabel from './shared/EditorSectionLabel.vue'
export default {
  name: 'EditorSocialsPanel',
  components: { EditorPanel, EditorSectionLabel },
  props: {
    siteSetting: {
      type: Object,
      required: true
    },
    socials: {
      type: Array,
      default: () => []
    },
    listSocials: {
      type: Array,
      default: () => []
    },
    loadingSave: {
      type: Boolean,
      default: false
    },
    socialsBar: {
      type: Array,
      default: () => ['instagram', 'facebook', 'x', 'tiktok']
    }
  },
  data() {
    return {
      selectedSocial: null,
      dialog: false,
      modalAddStyleColor: false,
      styleSocial: {
        color: '000',
        border: 12
      },
      currentIndex: 0,
      newSocial: {
        name: '',
        nick: ''
      },
      changes: {},
      rules: {
        required: value => !!value || this.$t('navbar.required')
      }
    }
  },
  computed: {
    countSocials() {
      return this.socials.length
    },
    socialItems() {
      return this.countSocials > 0 ? this.socials : [
        { name: 'instagram', nick: '' },
        { name: 'facebook', nick: '' },
        { name: 'tiktok', nick: '' }
      ]
    },
    validNick() {
      return this.rules.required(this.newSocial.nick) === true
    },
    colorPersonalized: {
      get() {
        return this.styleSocial.color ? `#${this.styleSocial.color}` : ''
      },
      set(value) {
        this.styleSocial.color = value.replace('#', '')
      }
    },
    currentImage() {
      const name = this.listSocials[this.currentIndex]?.value || 'instagram';
      return `https://backend.harmony.fan/storage/socials/no-styles/${name}.png`;
    }
  },
  watch: {
    socials: {
      handler(newVal) {
        newVal.forEach(social => {
          this.$set(this.changes, social.name.toLowerCase(), false)
        })
      },
      immediate: true
    },
    'siteSetting.style_socials': {
      handler(newVal) {
        if (typeof newVal === 'object') {
          this.styleSocial.color = newVal.color || '000'
          this.styleSocial.border = newVal.border || 12
        }
        this.selectedSocial = newVal
      },
      immediate: true
    }
  },
  methods: {
    socialStyleIcon(styleIndex, name) {
      return `https://backend.harmony.fan/storage/socials/${styleIndex}/${name}.svg`;
    },
    setSocialStyle(value) {
      if (!this.loadingSave) {
        this.selectedSocial = value
        this.$emit('set-social-style', value)
      }
    },
    addStyleColor() {
      this.modalAddStyleColor = true
    },
    saveStyleColor() {
      this.$emit('set-social-style', {
        color: this.styleSocial.color,
        border: this.styleSocial.border
      })
      this.modalAddStyleColor = false
    },
    handleInput(key) {
      this.$set(this.changes, key, true)
    },
    saveSocial(item) {
      this.$emit('save-social', item)
      this.$set(this.changes, item.name.toLowerCase(), false)
    },
    deleteSocial(item) {
      this.$emit('delete-social', item)
    },
    showAddDialog() {
      this.newSocial = { name: '', nick: '' }
      this.dialog = true
    },
    saveNewSocial() {
      this.$emit('save-social', { ...this.newSocial })
      this.dialog = false
      this.newSocial = { name: '', nick: '' }
    },
    getSocialStyle(value) {
      return this.$t('harmony.style') + value
    },
    getSocialPlaceholder(value) {
      switch (true) {
        case value == 'whatsapp':
          return this.$t('harmony.whatsapp-label')
        case value == 'email':
          return this.$t('harmony.mail-label')
        default:
          return this.$t('harmony.enter-username')
      }
    }
  }
}
</script>

<style scoped>
@import './editor-panel.css';

.socials-div {
  min-height: 65px;
  overflow: visible;
}

.socials-icon {
  width: 30px;
}

.plus-social-style {
  width: 32px;
  height: 32px;
  background-color: rgb(255, 255, 255);
  border: 2px solid var(--editor-color-primary);
  cursor: pointer;
}

.plus-social-style:hover {
  background-color: var(--editor-color-primary-hover);
}

.setSocialsStyle {
  width: 72px;
  height: 72px;
  display: flex;
}

.style-socials {
  width: 24px;
  height: 24px;
}

.style-socials img {
  max-width: 14px;
  max-height: 14px;
}

.icon-redes {
  width: 24px;
  margin: auto;
}

.modal-social-color {
  overflow: visible !important;
  width: 100%;
  height: 100%;
}

.selected-icon {
  color: var(--editor-color-primary);
}
</style>
